import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import TableCell from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';

import { CSVColumn, humanizeCsvHeader } from '~utils/csv/csvProcessor';

export function CSVColumnLabelCell({ column }: { column: CSVColumn }) {
  return (
    <TableCell>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, whiteSpace: 'nowrap' }}>
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          {column.label ?? humanizeCsvHeader(column.header)}
        </Typography>
        {column.required && (
          <Chip
            label={t('csv_import_export.field_reference.required')}
            size="small"
            variant="outlined"
            sx={{ height: 20, fontSize: 11 }}
          />
        )}
      </Box>
    </TableCell>
  );
}
